import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { guid_mapping } from "../common/Contants";
import EditFile from "../components/editDocument_components/EditFile";
import NextButton from "../components/editDocument_components/NextButton";
import { ComponentStruct, DocumentStruct } from "../common/Interfaces";
import EditDocumentDescription from "../components/editDocument_components/EditDocumentDescription";
import "../common/Contants";
import SelectDocumentType from "../components/addDocument_components/SelectDocumentType";
import SelectLanguages from "../components/generic_components/SelectLanguages";
import Reason from "../components/generic_components/Reason";
import Comment from "../components/generic_components/Comment";
import { ClearButton } from "../components/generic_components/ClearButton";
import ErrorMessage from "../components/generic_components/ErrorMessage";

export default function EditDocument() {
  const location = useLocation();
  const document: DocumentStruct = location.state?.editDocumentState.document;
  const defaultType = guid_mapping.find(
    (item) => item.guid == document.documentType.guid
  )?.type || { key: "0", label: "deselect" };
  const defaultDescription =
    guid_mapping.find((item) => item.guid == document.documentType.guid)
      ?.description || null;
  const [selectedType, setSelectedType] =
    useState<ComponentStruct>(defaultType);
  const [selectedDescription, setSelectedDescription] =
    useState<ComponentStruct | null>(defaultDescription);
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>(
    document.languages
  );
  const [selectedComment, setSelectedComment] = useState<string | null>(
    document.comments
  );
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<string>(document.file);
  const [clear, setClear] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const hide: boolean = process.env.REACT_APP_HIDE === "true";

  return (
    <>
      <EditDocumentDescription document={document} />
      <Row className="padding-top">
        <h4>Edit Document</h4>
      </Row>
      {errorMessages.length > 0 && <ErrorMessage errors={errorMessages} />}
      <SelectDocumentType
        clear={clear}
        descriptionDefaultValue={defaultDescription}
        typeDefaultValue={defaultType}
        onChange={(type, description) => {
          setSelectedDescription(description);
          setSelectedType(type);
        }}
      />
      <SelectLanguages
        allLanguages={false}
        clear={clear}
        defaultLanguages={document.languages}
        onChange={(selected) => setSelectedLanguages(selected)}
      />
      <EditFile
        clear={clear}
        fileDefaultValue={document.file}
        linkType={document.linkType}
        onChange={(file) => {
          setSelectedFile(file);
        }}
        onError={(error) => {
          setErrorMessages([error]);
        }}
      />
      <Comment
        commentDefaultValue={document.comments || ""}
        clear={clear}
        onChange={(comment: string) => {
          setSelectedComment(comment);
        }}
      />
      {!hide && (
        <Reason
          clear={clear}
          onChange={(reason: string | null) => {
            setSelectedReason(reason);
          }}
        />
      )}
      <Row>
        <Col className="d-flex justify-content-end">
          <ClearButton clear={clear} onClear={setClear} />
          <NextButton
            selectedType={selectedType}
            selectedDescription={selectedDescription}
            selectedLanguages={selectedLanguages}
            selectedFile={selectedFile}
            selectedReason={selectedReason}
            documentReference={document.documentReference}
            linkType={document.linkType}
            onErrorMessages={setErrorMessages}
            selectedComment={selectedComment}
          />
        </Col>
      </Row>
    </>
  );
}
